import React from 'react';
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles/index';
import createStyles from '@material-ui/core/styles/createStyles';


const styles = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
});

interface Props extends WithStyles<typeof styles> {
  items: JSX.Element[];
}

const Toolbox = (props: Props) => {
  const { classes, items } = props;
  return <div className={classes.root}>{items}</div>;
};

export default withStyles(styles)(Toolbox);
